import React from 'react';

const PageBanner = ({ title, subtitle }) => (
  <section className="bg-gradient-to-r from-[#79c9ea] to-[#5ba8c8] text-white py-16" data-testid="page-banner">
    <div className="max-w-6xl mx-auto px-4 text-center">
      <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-3 uppercase tracking-wide" data-testid="page-banner-title">
        {title}
      </h1>
      {subtitle && <p className="text-base sm:text-lg lg:text-xl opacity-90">{subtitle}</p>}
    </div>
  </section>
);

export default PageBanner;
